import b from 'b_';
import { Text, Spin, Link } from 'platform-components';
import React from 'react';

interface Props {
    problemsCount: number;
    shouldShowTag?: boolean;
}

const ThemePageStackPlaceholder = React.memo(({ problemsCount, shouldShowTag }: Props) => {
    if (!problemsCount) {
        return null;
    }

    return (
        <div className={b('theme-page', 'item', { loading: true })}>
            <div className="theme-page__item-wrapper">
                <div className="theme-page__problem">
                    <Spin center />
                </div>
                <div className="theme-page__item-body">
                    {shouldShowTag && (
                        <div className="theme-page__item-tag">
                            <Text size={Text.SIZE.S} />
                        </div>
                    )}
                    <Link
                        className={b('theme-page', 'add-link', { disabled: true })}
                        disabled
                        theme={Link.THEME.PRIMARY}
                    >
                        <Text id="library.item.addToLesson" weight={Text.WEIGHT.M} />
                    </Link>
                </div>
            </div>
        </div>
    );
});

export default ThemePageStackPlaceholder;
